<template>
    <input type="text" inputmode="decimal" class="form-control" :class="{'form-control-sm': size === 'sm'}" :value="formatted" @input="onInput" @blur="$emit('blur', $event)" @change="$emit('change', normalize($event.target.value))">
</template>
<script>
import moneyInput from './payrollMoneyInput';

export default {
    name: 'PayrollMoneyInput',
    props: {value: {type: [String, Number], default: ''}, size: {type: String, default: ''}},
    computed: {formatted() { return moneyInput.format(this.value); }},
    methods: {
        normalize: moneyInput.normalize,
        onInput(event) {
            const input = event.target;
            const before = moneyInput.ungroup(input.value.slice(0, input.selectionStart)).length;
            const normalized = moneyInput.normalize(input.value);
            const formatted = moneyInput.format(input.value);
            input.value = formatted;
            this.$emit('input', normalized);
            this.$nextTick(() => {
                if (document.activeElement === input) {
                    const position = moneyInput.caret(formatted, before);
                    input.setSelectionRange(position, position);
                }
            });
        }
    }
};
</script>
